import { client } from 'lib/graphql/client';
import { gql } from '@apollo/client';
import { Locale } from 'generated/graphql';

export async function getDictionary(locale: string, title: string) {
  return client.query({
    query: gql`
        query GetDictionary {
            dictionary(where: {dictionaryTitle: "${title}"}, locales: [${locale}, ${Locale.default}]) {
                dictionaryItems(first: 1000) {
                    key
                    value
                }
            }
        }
    `,
  });
}
